import googleSheetsIcon from 'assets/google-sheets-logo.svg';
import mailchimpIcon from 'assets/mailchimp.svg';
import { ChannelType } from '../../../../liveChat/components/ChannelIcon';
import { ConnectableChannel } from '../../Automations/AutomationEdit/InputTriggers/use-channel-connection';
import clipIcon from './Icons/clip-icon.svg';
import powerIcon from './Icons/power-icon.svg';
import applicationIcon from './Icons/application-icon.svg';
import emailIcon from './Icons/email-icon.svg';
import inboxIcon from './Icons/inbox-icon.svg';
import magicWandIcon from './Icons/magic-wand.svg';
import createAutomationIcon from './Icons/create-automation-icon.svg';
import installApplicationIcon from './Icons/install-application-icon.svg';
import checkInboxIcon from './Icons/check-inbox-icon.svg';
import billingAddressIcon from './Icons/add-billing-address-icon.svg';
import environmentOutlined from './Icons/environment-outlined.svg';
import xrayImage from './Images/image_xray.jpg';
import createXRayIcon from '../../Automations/AutomationEdit/InputTriggers/icons/x-ray.svg';

export type EducationalCardType =
  | 'xray'
  | 'facebook'
  | 'instagram'
  | 'sms'
  | 'email'
  | 'create_automation'
  | 'visit_inbox'
  | 'download_app'
  | 'confirm_email'
  | 'connect_google_sheets'
  | 'connect_mailchimp'
  | 'billingAddress';

export const EDUCATIONAL_CARD_TYPES = [
  'xray',
  'visit_inbox',
  'email',
  'create_automation',
  'billingAddress',
  // 'sms',
  // 'facebook',
  // 'instagram',
  // 'download_app',
  // 'confirm_email',
  // 'connect_google_sheets',
  // 'connect_mailchimp',
] as const;
export type EducationalCards = typeof EDUCATIONAL_CARD_TYPES[number];

export interface EducationalCard {
  channel?: ChannelType;
  icon?: string;
  heading: string;
  subheading?: string;
  description: string;
  descriptionImage?: string;
  columnSpan?: number;
  button: string;
  backgroundImage: string;
  dismissable?: boolean;
  priority: number;
}

export interface EducationalCardDefinition {
  channel?: ChannelType;
  icon?: string;
  heading: string;
  subheading?: string;
  description: string;
  button: string;
  backgroundImage: string;
  descriptionImage?: string;
  dismissable?: boolean;
  priority: number;
  cardType?: EducationalCardType;
  connectableChannelType?: ConnectableChannel;
  columnSpan?: number;
}

export const EDUCATIONAL_CARD_DEFINITIONS: Record<
  EducationalCardType,
  EducationalCard
> = {
  xray: {
    heading: 'Install X-Ray Pixel Trigger',
    subheading: 'X-Ray Pixel captures leads from your anonymous web traffic',
    description:
      'Install the script & capture leads without coupons, popups, or widgets. Automatic anonymous lead capture.',
    descriptionImage: xrayImage,
    icon: createXRayIcon,
    button: 'Install X-Ray Pixel',
    backgroundImage: magicWandIcon,
    columnSpan: 2,
    priority: 1,
  },
  billingAddress: {
    heading: 'Add your Billing Address',
    description:
      'Your billing address protects you through the Address Verification System.',
    button: 'Add Billing Address',
    icon: environmentOutlined,
    backgroundImage: billingAddressIcon,
    dismissable: true,
    priority: 1,
  },
  email: {
    channel: 'email',
    heading: 'Connect Your Email for Outreach',
    description:
      'Connect your accounts to use our deliverability tools and land in the inbox every time.',
    button: 'Connect Email',
    backgroundImage: emailIcon,
    dismissable: false,
    priority: 1,
  },
  sms: {
    channel: 'sms',
    heading: 'Activate an SMS Text Messaging Phone Number',
    description:
      'So that you can do outreach and follow up via SMS Text Messages. Available in US & Canada only.',
    button: 'Activate',
    backgroundImage: powerIcon,
    dismissable: true,
    priority: 1,
  },
  facebook: {
    channel: 'facebook',
    heading: 'Connect your Facebook Page to  Customers.ai',
    description:
      'So that you can follow up with your Facebook Engagers via Email and Text Messages',
    button: 'Connect',
    backgroundImage: clipIcon,
    dismissable: true,
    priority: 1,
  },
  instagram: {
    channel: 'instagram',
    heading: 'Connect your Instagram account to  Customers.ai',
    description:
      'So that you can follow up with your Instagram Engagers via Email and Text Messages',
    button: 'Connect',
    backgroundImage: clipIcon,
    dismissable: true,
    priority: 1,
  },
  confirm_email: {
    channel: 'email',
    heading: 'Confirm your Email Address',
    description: 'To protect the security of your account',
    button: 'Confirm',
    backgroundImage: emailIcon,
    dismissable: false,
    priority: 1,
  },
  create_automation: {
    icon: createAutomationIcon,
    heading: 'Create a new Automation',
    description:
      'Use our outreach automation to contact your warm leads from X-Ray Pixel.',
    button: 'Create Automation',
    backgroundImage: magicWandIcon,
    dismissable: false,
    priority: 2,
  },
  visit_inbox: {
    icon: checkInboxIcon,
    heading: 'Check your Inbox',
    description: 'So that you can respond to your Unicorn leads',
    button: 'To Inbox',
    backgroundImage: inboxIcon,
    dismissable: false,
    priority: 2,
    columnSpan: 2,
  },
  download_app: {
    icon: installApplicationIcon,
    heading: 'Install the  Customers.ai chat for iOS/Android',
    description:
      'So that you can be notified of Unicorn Leads at any time and respond while they are engaged',
    button: 'Install',
    backgroundImage: applicationIcon,
    dismissable: false,
    priority: 2,
  },
  connect_google_sheets: {
    icon: googleSheetsIcon,
    heading: 'Connect your Google Sheets account to  Customers.ai',
    description:
      'So that you can sync your leads in real time to a spreadsheet',
    button: 'Connect',
    backgroundImage: clipIcon,
    dismissable: true,
    priority: 3,
  },
  connect_mailchimp: {
    icon: mailchimpIcon,
    heading: 'Connect your Mailchimp account to Customers.ai',
    description: 'So that you can sync your leads in real time to a Mailchimp',
    button: 'Connect',
    backgroundImage: clipIcon,
    dismissable: true,
    priority: 3,
  },
};
